import { render, staticRenderFns } from "./gpsrTemplateView.vue?vue&type=template&id=4c25061b&scoped=true&"
import script from "./gpsrTemplateView.vue?vue&type=script&lang=js&"
export * from "./gpsrTemplateView.vue?vue&type=script&lang=js&"
import style0 from "./gpsrTemplateView.vue?vue&type=style&index=0&id=4c25061b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25061b",
  null
  
)

export default component.exports